var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColonial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 167,
    viewBox: "15 10 145 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #c6c6c6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke: #606060;\r\n        stroke-width: 1.1px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(257.762 -115.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-1",
    width: 173,
    height: 167,
    transform: "translate(-257.762 115.937)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    className: "cls-2",
    width: 88.5,
    height: 84.82,
    transform: "translate(-215.539 138.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-2",
    d: "M0,5.752l1.711-.141L3.421,5.2l1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8L13.685.549,15.4.141,17.107,0l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409,1.711.141,1.711-.141L37.635,5.2l1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8L47.9.549,49.61.141,51.32,0l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409,1.711.141,1.711-.141L71.848,5.2l1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8L82.112.549,83.823.141,85.534,0l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409,1.711.141,1.711-.141,1.711-.409,1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8,1.711-.636,1.711-.409L119.747,0l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409",
    transform: "translate(-119.618 227.91) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-3",
    d: "M1-10.248l1.711-.141L4.421-10.8l1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8,1.711-.636,1.711-.409L18.107-16l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409,1.711.141,1.711-.141,1.711-.409,1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8,1.711-.636,1.711-.409L52.32-16l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409,1.711.141,1.711-.141,1.711-.409,1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8,1.711-.636,1.711-.409L86.534-16l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409,1.711.141,1.711-.141,1.711-.409,1.711-.636,1.711-.8,1.711-.889,1.711-.889,1.711-.8,1.711-.636,1.711-.409L120.747-16l1.711.141,1.711.409,1.711.636,1.711.8,1.711.889,1.711.889,1.711.8,1.711.636,1.711.409",
    transform: "translate(-240.5 238.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    className: "cls-2",
    width: 22,
    height: 22,
    transform: "translate(-173.65 200.66) rotate(40)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    className: "cls-2",
    width: 22,
    height: 22,
    transform: "translate(-168.179 200.66) rotate(50)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    className: "cls-3",
    width: 40,
    height: 55,
    transform: "translate(-255.762 179.938)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    className: "cls-3",
    width: 40,
    height: 55,
    transform: "translate(-127.762 179.938)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    className: "cls-4",
    transform: "translate(-225.191 128.444)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 107.531,
    height: 140.475
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.55,
    y: 0.55,
    width: 106.431,
    height: 139.375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    className: "cls-4",
    transform: "translate(-215.814 137.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 88.776,
    height: 122.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.55,
    y: 0.55,
    width: 87.676,
    height: 121.67
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColonial);
export default __webpack_public_path__ + "static/media/Colonial.b5fc3ee916aa63ba7f7cb5cd5ed0bf11.svg";
export { ForwardRef as ReactComponent };